
































import Vue from "vue";

import IconSchedule from "@/components/icons/IconSchedule.vue";
import IconPhone from "@/components/icons/IconPhone.vue";
import IconMail from "@/components/icons/IconMail.vue";

import { Card } from "../Card";

interface IDepartment {
  id: number;
  name: string;
  mode: string;
  phone: any[];
  email: string;
}

export default Vue.extend({
  name: "department",
  components: { Card, IconSchedule, IconPhone, IconMail },
  props: {
    department: Object as () => IDepartment,
  },
});
